var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contact-details-container" }, [
    _c(
      "div",
      { attrs: { role: "radiogroup", "aria-label": _vm.radioGroupAriaLabel } },
      [
        _c("BaseRadio", {
          attrs: {
            click: _vm.radioLoginClick,
            name: _vm.radioLoginName,
            activeClass: _vm.radioLoginActive,
            "aria-checked": _vm.radioLoginChecked,
            ariaLabel: _vm.radioLoginAriaLabel
          }
        }),
        _vm._v(" "),
        _vm.radioLoginChecked
          ? _c(
              "div",
              { staticClass: "contact-form" },
              [
                !_vm.isLoggedIn
                  ? [
                      _c(
                        "div",
                        {
                          staticClass: "contact-field",
                          class: _vm.updatePhoneClass()
                        },
                        [
                          _c("BaseIcon", {
                            staticClass: "input-field-icon icon-mobile",
                            attrs: {
                              icon: "mobile",
                              isCustom: true,
                              size: "1x"
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.phone,
                                expression: "phone"
                              }
                            ],
                            staticClass: "input text-input has-icon",
                            attrs: {
                              type: "text",
                              placeholder: "Mobile Number"
                            },
                            domProps: { value: _vm.phone },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.phone = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("BaseButton", {
                            attrs: {
                              classNames: [
                                "button--modifier",
                                "input-field-button"
                              ],
                              title: "Login/Sign-up",
                              type: "fill"
                            },
                            on: { click: _vm.showLogin }
                          })
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.isLoggedIn
                  ? _c("div", { staticClass: "details-set-container" }, [
                      _c("div", { staticClass: "detail-info" }, [
                        _c("label", { attrs: { for: "login-customer-name" } }, [
                          _vm._v("Name: ")
                        ]),
                        _vm._v(" "),
                        _c("span", { attrs: { id: "login-customer-name" } }, [
                          _vm._v(_vm._s(_vm.customer.printFullName()))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "detail-info" }, [
                        _c(
                          "label",
                          { attrs: { for: "login-customer-phone" } },
                          [_vm._v("Phone: ")]
                        ),
                        _vm._v(" "),
                        _c("span", { attrs: { id: "login-customer-phone" } }, [
                          _vm._v(
                            _vm._s(_vm.printPhoneNumber(_vm.customer.phone))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "detail-info pad-top" }, [
                        _c("span", { attrs: { id: "logout-customer" } }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "/logout" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.logoutAction($event)
                                }
                              }
                            },
                            [_vm._v("Sign out")]
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.guestRadioEnabled
          ? _c("BaseRadio", {
              attrs: {
                click: _vm.radioGuestOrderClick,
                name: "Guest",
                activeClass: _vm.radioGuestOrderActive,
                "aria-checked": _vm.radioGuestOrderChecked,
                ariaLabel: "Complete order as a guest"
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.guestFormEnabled
          ? _c("div", { staticClass: "contact-form" }, [
              _c(
                "div",
                {
                  staticClass: "contact-field",
                  class: _vm.validateClass(_vm.hasValidName(_vm.guestNameModel))
                },
                [
                  _c("BaseIcon", {
                    staticClass: "input-field-icon",
                    attrs: { icon: "userEdit", size: "1x" }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.guestNameModel,
                        expression: "guestNameModel"
                      }
                    ],
                    staticClass: "input text-input has-icon",
                    attrs: { type: "text", placeholder: "Name" },
                    domProps: { value: _vm.guestNameModel },
                    on: {
                      blur: function($event) {
                        return _vm.updateName()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.guestNameModel = $event.target.value
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "contact-field",
                  class: _vm.validateClass(
                    _vm.hasValidEmail(_vm.guestEmailModel)
                  )
                },
                [
                  _c("BaseIcon", {
                    staticClass: "input-field-icon",
                    attrs: { icon: "email", size: "1x" }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.guestEmailModel,
                        expression: "guestEmailModel"
                      }
                    ],
                    staticClass: "input text-input has-icon",
                    attrs: { type: "email", placeholder: "Email" },
                    domProps: { value: _vm.guestEmailModel },
                    on: {
                      blur: function($event) {
                        return _vm.updateEmail()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.guestEmailModel = $event.target.value
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "contact-field", class: _vm.updatePhoneClass() },
                [
                  _c("BaseIcon", {
                    staticClass: "input-field-icon",
                    attrs: { icon: "phone", size: "1x" }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.phone,
                        expression: "phone"
                      }
                    ],
                    staticClass: "input text-input has-icon",
                    attrs: { type: "tel", placeholder: "Phone (607) 123 4567" },
                    domProps: { value: _vm.phone },
                    on: {
                      blur: function($event) {
                        return _vm.updatePhone()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.phone = $event.target.value
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _vm._m(0)
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade", mode: "in-out" } }, [
          _vm.errorMessage && !_vm.isLoggedIn
            ? _c("p", { staticClass: "error" }, [
                _vm._v(_vm._s(_vm.errorMessage))
              ])
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "is-size-7 has-text-grey-light" }, [
      _vm._v(
        '\n\t\t\t\tBy clicking on the "Place Order" button, you agree to our\n\t\t\t\t'
      ),
      _c(
        "a",
        {
          staticClass: "has-text-grey-light",
          attrs: {
            target: "_blank",
            href: "https://www.touchpoint.io/privacy.php"
          }
        },
        [_vm._v("\n\t\t\t\t\tTerms of Service\n\t\t\t\t")]
      ),
      _vm._v("\n\t\t\t\tand\n\t\t\t\t"),
      _c(
        "a",
        {
          staticClass: "has-text-grey-light",
          attrs: {
            target: "_blank",
            href: "https://www.touchpoint.io/privacy.php"
          }
        },
        [_vm._v("\n\t\t\t\t\tPrivacy Policy\n\t\t\t\t")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f999226", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f999226","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/ContactDetails/ContactDetails.vue
// module id = null
// module chunks = 